import VueCookie from 'vue-cookie';
import axios from 'axios'; 

const COOKIE_FIELD_VALUE_STRING = 'value=';

const GAInterceptors = function (config) {
  let token = '';
  token = getTokenFromCookie();

  config.headers.common['X-FERCAM-GLOBAL-AUTH'] = token;
  return config;
};

let isAlreadyFetchingAccessToken = false;
const GAInterceptorsOnError = function (error) {
  const {
    config,
    response: { status },
  } = error;

  const originalRequest = config;

  if (status === 401) {
    if (!isAlreadyFetchingAccessToken) {
      isAlreadyFetchingAccessToken = true;
      const token = getTokenFromCookie();

      fetch(
        `${process.env.VUE_APP_GLOBALAUTH_API}Login/RefreshToken/${token}`,
        
      )
        .then(response => response.json())
        .then((newToken) => {
          if (newToken) {
            refreshToken(newToken);
            onRrefreshed(newToken);
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    }

    const retryOriginalRequest = new Promise((resolve) => {
      subscribeTokenRefresh((token) => {
        originalRequest.headers['X-FERCAM-GLOBAL-AUTH'] = token;
        resolve(axios(originalRequest));
      });
    });
    return retryOriginalRequest;
  }
  return Promise.reject(error);

};

var getTokenFromCookie = function () {
  const cookieValue = VueCookie.get('GlobalAuthUser');

  if (cookieValue) {
    const token = cookieValue
      .split('&')
      .find(s => s.indexOf(COOKIE_FIELD_VALUE_STRING) > -1)
      .replace(COOKIE_FIELD_VALUE_STRING, '');
    return token;
  }
  return '';

};

var refreshToken = function (token) {
  const cookieValue = VueCookie.get('GlobalAuthUser');

  const GACookie = cookieValue.split('&');
  if (GACookie) {
    GACookie[0] = COOKIE_FIELD_VALUE_STRING + token;

    var now = new Date();
    var time = now.getTime();
    // 180 days
    var expireTime = time + 1000*86400*180;
    now.setTime(expireTime);
    
    var currentDomain = window.location.hostname.split('.').reverse().slice(0,2).reverse().join("."); 

    const newCookie = GACookie.join('&');
    document.cookie = `GlobalAuthUser=${newCookie};domain=${currentDomain};expires=${now.toUTCString()};path=/`;
  }
};

const refreshSubscribers = [];

function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb);
}

function onRrefreshed(token) {
  refreshSubscribers.map(cb => cb(token));
}

export default { GAInterceptors, GAInterceptorsOnError };
